// Attendance status pill. The status is the server's (self check-in, trainer
// marks); this only maps it to a label + colour. No status = "Not recorded".
import { useT } from '../lib/i18n';
import React from 'react';
import type { AttendanceStatus } from '@/services/learningService';

export const ATTENDANCE_STATUSES: AttendanceStatus[] = ['invited', 'confirmed', 'attended', 'partially_attended', 'absent', 'excused', 'cancelled'];

const CLS: Record<AttendanceStatus | 'none', string> = {
  attended: 'bg-success-soft text-success-strong',
  partially_attended: 'bg-success-soft text-success-strong',
  confirmed: 'bg-blue-100 text-blue-700 dark:bg-blue-500/[0.16] dark:text-blue-300',
  absent: 'bg-red-100 text-red-700 dark:bg-red-500/[0.16] dark:text-red-300',
  excused: 'bg-muted text-muted-foreground',
  cancelled: 'bg-muted text-muted-foreground line-through',
  invited: 'bg-muted text-muted-foreground',
  none: 'bg-muted text-muted-foreground',
};

export const attendanceLabel = (t: (k: string, d: string) => string, status?: AttendanceStatus | null): string => {
  switch (status) {
    case 'attended': return t('training:att_attended', 'Attended');
    case 'partially_attended': return t('training:att_partial', 'Partially attended');
    case 'confirmed': return t('training:att_confirmed', 'Confirmed');
    case 'absent': return t('training:att_absent', 'Absent');
    case 'excused': return t('training:att_excused', 'Excused');
    case 'cancelled': return t('training:att_cancelled', 'Cancelled');
    case 'invited': default: return t('training:att_not_recorded', 'Not recorded');
  }
};

export const AttendanceChip: React.FC<{ status?: AttendanceStatus | null; className?: string }> = ({ status, className }) => {
  const t = useT();
  return (
    <span data-testid="attendance-chip" data-status={status || 'none'}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${CLS[status || 'none'] || CLS.none} ${className || ''}`}>
      {attendanceLabel(t, status)}
    </span>
  );
};

export default AttendanceChip;
